export interface BarcodeScannerProps {
  visible: boolean;
  onClose: () => void;
  onScanned: (value: string) => void;
}

// Web stub — VisionCamera is native-only.
// This file prevents webpack from bundling react-native-vision-camera on web.
const BarcodeScanner = (_props: BarcodeScannerProps) => null;

export default BarcodeScanner;
